import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap, catchError, map } from 'rxjs';
import { Store, Action } from '@ngrx/store';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { ApplicationState } from '../../store/application-store';

import * as profileActions from '../actions/profiles';
import { ProfileHttpService } from '../services/profile-http.service';
import { Profile } from '../models/profile';


@Injectable()
export class ProfileEffects {

  constructor(
    private actions$: Actions,
    private profileHttpService: ProfileHttpService,
    private store: Store<ApplicationState>) {
  }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<profileActions.LoadAll>(profileActions.LOAD_ALL),
    mergeMap((action) => {
      return this.profileHttpService.getAll(action.product).pipe(
        map((profiles: Profile[]) => new profileActions.LoadAllComplete(profiles)),
        catchError(err => of(new profileActions.LoadAllError(err)))
      );
    })));

}
